import React, { Component } from 'react'
import * as s from './ProgressBar.module.css'
export default class ProgressBar extends Component {
    render() {
        return (
            <div className={s.wrapper}>
                <div style={{width:this.props.width}} className={s.ProgressBar}></div>
            </div>
        )
    }
}
